import { useCallback, useMemo } from "react";
import { toast } from "react-toastify";

const useIframeColorsList = (iframeRef) => {
    const getPathTo = useCallback(
        (element) => {
            if(Array.isArray(element)) {
                return element.map((item) => getPathTo(item));
            }

            if (element.id!=="")
                return "//" + element.tagName.toLowerCase() + "[@id=\""+element.id+"\"]";

            if (element===document.body)
                return element.tagName.toLowerCase();

            var ix= 0;
            if (element.parentNode) {
                var siblings = element.parentNode.childNodes;
                for (var i = 0; i < siblings.length; i++) {
                    var sibling = siblings[i];
                    if (sibling === element)
                        return getPathTo(element.parentNode) + "/" + element.tagName.toLowerCase() + "[" + (ix + 1) + "]";
                    if (sibling.nodeType === 1 && sibling.tagName === element.tagName)
                        ix++;
                }
            }
        },
        []
    );

    const getElementsByText = useCallback(
        (text) => {
            const iframe = iframeRef.current;
            const iframeDocument = iframe?.contentWindow || (iframe?.contentDocument?.document || iframe?.contentDocument);

            if(!iframeDocument) {
                return;
            }

            let elements = iframeDocument.document.getElementsByTagName("*");
            const result = [];

            for (let i=0 ; i < elements.length; i++) {
                if(elements[i].innerText === text) {
                    result.push(elements[i]);
                }
            }

            return result;
        },
        [ iframeRef ]
    );

    const getElementByXpath = useCallback(
        (path) => {
            if(!iframeRef) {
                return;
            }

            const iframe = iframeRef.current;
            let results = [];

            try {
                let nodesSnapshot = document.evaluate(
                    path,
                    iframe?.contentDocument,
                    null,
                    XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
                    null
                );


                for (let i=0 ; i < nodesSnapshot.snapshotLength; i++) {
                    results.push(nodesSnapshot.snapshotItem(i));
                }

                return results;
            } catch (error) {
                toast.error("There is no such selector.");

                return results;
            }
        },
        [ iframeRef ]
    );

    const clearCssClassName = useCallback(
        (className) => {
            const iframe = iframeRef.current;
            const iframeDocument = iframe?.contentWindow || (iframe?.contentDocument?.document || iframe?.contentDocument);

            if(!iframeDocument || !className) {
                return;
            }

            let elements = 1;

            while(elements.length !== 0) {
                elements = iframeDocument.document.getElementsByClassName(className);

                for (let i=0 ; i < elements.length; i++){
                    elements[i].classList.remove(className);
                }
            }
        },
        [ iframeRef ]
    );

    const highlightElement = useCallback(
        (xpath, className) => {
            let elements;

            if(Array.isArray(xpath)) {
                elements = xpath.reduce(
                    (acc, item) => {
                        const newArr = getElementByXpath(item);

                        return [ ...acc, ...newArr ];
                    },
                    []
                );
            } else {
                elements = getElementByXpath(xpath);
            }

            if(!elements || !elements.length) {
                return;
            }

            elements.forEach((element) => {
                element.classList.add(className);
            });
        },
        [ getElementByXpath ]
    );

    return useMemo(
        () => ({
            getPathTo,
            getElementsByText,
            getElementByXpath,
            clearCssClassName,
            highlightElement
        }),
        [
            getPathTo,
            getElementsByText,
            getElementByXpath,
            clearCssClassName,
            highlightElement
        ]
    );
};

export default useIframeColorsList;
